import React, { useState, useEffect } from "react";
import { Typography, AppBar, Toolbar } from "@mui/material";
import { useParams } from "react-router-dom";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { isLoggedIn } from "../session";
import { useNavigate } from "react-router-dom";
import Atras from "./atras";

function Header() {
  const { productId } = useParams();
  const [productName, setProductName] = useState(""); // Nuevo estado para el nombre del producto


  useEffect(() => {
    const fetchProductData = async () => {
      try {
        const db = getFirestore();
        const productDocRef = doc(db, "products", productId);
        const productDocSnapshot = await getDoc(productDocRef);

        if (productDocSnapshot.exists()) {
          const productData = productDocSnapshot.data();
          const name = productData.title || "Producto";
          setProductName(name);
        } else {
          console.error("El producto no existe");
        }
      } catch (error) {
        console.error("Error fetching product data:", error);
      }
    };

    if (productId) {
      fetchProductData();
    }
  }, [productId]);

  let navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn()) {
      navigate("/login");
    }
  }, [navigate]);

  return (
    <AppBar position="fixed">
      <Toolbar sx={{ padding: "7px" }}>
        <Atras />
          {productName && (
            <Typography
              variant="h6"
              sx={{ paddingLeft: "24px",fontSize: "24px", color: "white" }}
              gutterBottom
            >
              {`${productName}`}
            </Typography>
          )}
      </Toolbar>
    </AppBar>
  );
}

export default Header;
